import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getSafely} from 'shared/web';

import {useGetApiCountriesQuery, useGetTrimLevelsQuery} from '../store/catalogueApi';
import {PriceReportType} from '../types/PriceReportType';

export function useTrimLevelsCatalog(
  priceReport: PriceReportType,
  yearFrom: number | null | undefined,
  yearTo: number | null | undefined
) {
  const {data: apiCountries, isLoading: isApiCountriesLoading} = useGetApiCountriesQuery({
    format: 'iso3',
  });
  const {data: trimLevels, isLoading: isTrimLevelsLoading} = useGetTrimLevelsQuery({
    modelFamily: priceReport.vehicle.modelFamily,
    make: priceReport.vehicle.make,
    country: getSafely(apiCountries, priceReport.market),
    yearFrom: yearFrom ?? undefined,
    yearTo: yearTo ?? undefined,
  });

  const catalog = trimLevels?.trim_levels;
  const isLoaded = !isApiCountriesLoading && !isTrimLevelsLoading;
  const hasTrimLevels = isLoaded && isNotNilOrEmpty(catalog);

  return {catalog, hasTrimLevels, isLoading: !isLoaded};
}
